import Swal from "sweetalert2";
import {validation} from "../../helpers/validation";
//
let arrayObjModelToCart = []
let href = location.href
let itemsFromStorage;
let showLoader = false
let lang;


window.notify = function (text, type = 'success') {
    Swal.close();
    Swal.fire({
        position: 'top-end',
        icon: type,
        title: text,
        showConfirmButton: false,
        showCloseButton: true,
        timer: 2500,
        timerProgressBar: true,
        toast: true,
    })
}

$('body').on('click', '.js-minus-btn', function (e) {
    e.preventDefault();
    let $this = $(this);
    let $input = $this.closest('div').find('input');
    let value = parseInt($input.val());
    if (value > 1) {
        $('.js-minus-btn').removeAttr('disabled');
        value = value - 1;
    } else {
        $('.js-minus-btn').prop('disabled', true);
        value = 1;
    }

    $input.val(value);
});

$('body').on('click', '.js-plus-btn', function (e) {
    e.preventDefault();
    let $this = $(this);
    let $input = $this.closest('div').find('input');
    let value = parseInt($input.val());
    if( value > 0) {
        $('.js-minus-btn').removeAttr('disabled');
    }
    if (value < 100) {
        value = value + 1;
    } else {
        value = 100;
    }
    $input.val(value);
});

let colorName,
    chooseColorName,
    category,
    material,
    layerHeight,
    infillPercentage,
    totalPriceName

// $('.js-create-order').on('click', (e) => {
//     let form = $('.js-form-cart-send-phone')
//     let code = $('.js-cart-phone-block').find('.iti__selected-dial-code').html()
//
//     if ($('.shopping-cart').hasClass('js-user-have-phone')) {
//         createOrder()
//     } else {
//         $.ajax({
//             type: "POST",
//             url: '/user/update',
//             data: {
//                 first_name: $('.js-cart-first-name').val(),
//                 last_name: $('.js-cart-last-name').val(),
//                 email: $('.js-cart-phone').val() !== '' && $('.js-cart-email').val(),
//                 phone: $('.js-cart-phone').val() !== '' && code + $('.js-cart-phone').val()
//             },
//             success: function (response) {
//                 createOrder()
//             },
//             error: function (xhr) {
//                 $('.js-cart-phone').parent('div').find('.error-text').html('Phone is required')
//                 $('.js-cart-phone').parent('div').find('.error-text').css('display', 'block')
//                 $('.js-cart-phone').addClass('border-danger')
//             }
//         });
//
//         return false
//     }
// })
// $('.js-cart-phone').on('input', () => {
//     $('.js-cart-phone').parent('div').find('.error-text').html('')
//     $('.js-cart-phone').removeClass('border-danger')
// })

// function createOrder() {
//     let dataToAjax = []
//     $('.item').each((index, item) => {
//         let objData = {}
//         objData.model_id = $(item).data('id')
//         objData.count = $(item).find('.quantity input[name="name"]').val()
//         objData.type = $(item).find('.quantity input[name="type"]').attr('data-type')
//
//         dataToAjax.push(objData)
//     })
//
//     $.ajax({
//         type: "POST",
//         url: '/order',
//         data: {
//             order: dataToAjax,
//             address_id: $('.js-cart-address').val()
//         },
//         success: function (response) {
//             if (localStorage.getItem('lang') === 'ar-sa') {
//                 window.notify('تم إنشاء الطلب')
//
//             } else {
//                 window.notify('Order created')
//
//             }
//             localStorage.removeItem('cart')
//             window.location.href = '/user/orders'
//
//             // $('#modal-cart').modal('hide')
//         },
//         error: function (xhr) {
//             if (localStorage.getItem('lang') === 'ar-sa') {
//                 window.notify('لم يتم إنشاء الطلب. الرجاء استبدال المنتج', 'error')
//
//             } else {
//                 window.notify('Order not created. Try to replace the product', 'error')
//
//             }
//             $('.js-cart-address').parent('div').find('.error-text').html('Address is required')
//             $('.js-cart-address').parent('div').find('.error-text').css('display', 'block')
//             $('.js-cart-address').addClass('border-danger')
//         }
//     });
// }

$('body').on('click', '.fa-cart-shopping', e => {
    arrayObjModelToCart = JSON.parse(localStorage.getItem(`cart-${userId}`))
    if (localStorage.getItem('lang') === 'ar-sa') {
        lang = 'ar-sa'
        colorName = 'اللون'
        chooseColorName = 'اختر اللون'
        category = 'نوع الدعم'
        material = 'نوع المادة'
        layerHeight = 'دقة الطباعة'
        infillPercentage = 'كثافة الحشوة'
        totalPriceName = 'السعرالاجمالي'

    } else {
        lang = 'en'
        totalPriceName = 'Total price'
        colorName = 'Color'
        chooseColorName = 'Choose color'
        category = 'Category'
        material = 'Material'
        layerHeight = 'Layer Height'
        infillPercentage = 'Infill Percentage'
    }

    setTimeout(() => {

        // $('#modal-cart').hasClass('show') && changePrice()
        let items = $('.item')

        $(items).each((index, item) => {
            if ($(item).attr('data-type') === 'App\\Models\\Model\\ClientModel') {
                localStorage.getItem('lang') === 'ar-sa' ? $('.js-create-order').html('إنشاء النظام') : $('.js-create-order').html('Create order')
            }
        })

    }, 500)
})
//
// $('body').on('click', '.js-register-from-cart-btn', (e) => {
//     e.preventDefault()
//     $('.js-login-from-cart').addClass('d-none')
//     $('.js-register-from-cart').removeClass('d-none')
// })
// $('body').on('click', '.js-login-from-cart-btn', (e) => {
//     e.preventDefault()
//     $('.js-login-from-cart').removeClass('d-none')
//     $('.js-register-from-cart').addClass('d-none')
// })
// $('body').on('click', '.js-btn-cart-create-address', (e) => {
//     let form = $('.js-cart-addresses-create');
//     $.ajax({
//         type: "post",
//         url: form.data('url'),
//         data: form.serialize(),
//         success: function (response) {
//             localStorage.setItem('open', JSON.stringify(true));
//             if (localStorage.getItem('lang') === 'ar-sa') {
//                 response && window.notify('تم إنشاء العنوان')
//             } else {
//                 response && window.notify('Address created')
//
//             }
//
//             window.location.reload()
//
//         },
//         error: function (xhr) {
//             if (localStorage.getItem('lang') === 'ar-sa') {
//                 window.notify('لم يتم إنشاء العنوان', 'error')
//             } else {
//                 window.notify('Address not created', 'error')
//
//             }
//
//             let response = JSON.parse(xhr.responseText);
//             validation(form[0], response.errors, true);
//         }
//     });
// })

// $('body').on('click', '.js-use-promocode', e => {
//     totalPrice()
//     let code = $('.js-promocode').val();
//     if ($(e.target).is(':checked') && !code) {
//         $('.js-create-order').attr('disabled', 'true')
//     } else {
//         $('.js-create-order').removeAttr('disabled')
//     }
//
//     if ($(e.target).is(':checked') && code.length > 4) {
//         // usePromocode(code)
//     }
// })

// $('body').on('input', '.js-promocode', e => {
//     totalPrice()
//     let code = $('.js-promocode').val();
//     if ($('.js-use-promocode').is(':checked') && !code) {
//         $('.js-create-order').attr('disabled', 'true')
//     } else {
//         $('.js-create-order').removeAttr('disabled')
//     }
//
//     if ($('.js-use-promocode').is(':checked') && code.length > 4) {
//         usePromocode(code)
//     }
// })

// function usePromocode(code) {
//     $.ajax({
//         type: "get",
//         url: `/discount/${code}`,
//         success: function (response) {
//
//             let price = $('.full-price h4').attr('data-price')
//
//             if (response.data) {
//                 if (response.data.discount_type === 1) {
//                     let newPrice = +price - (+price / 100 * response.data.discount)
//                     $('.full-price h4').html(`${totalPriceName} ` + Math.floor(newPrice * 100) / 100 + ' ر.س ')
//                     $('.full-price h4').attr('data-price', Math.floor(newPrice * 100) / 100)
//                 } else if (response.data.discount_type === 0) {
//                     let newPrice = +price - response.data.discount
//                     $('.full-price h4').html(`${totalPriceName} ` + Math.floor(newPrice * 100) / 100 + ' ر.س ')
//                     $('.full-price h4').attr('data-price', Math.floor(newPrice * 100) / 100)
//                 }
//                 $('.js-promocode').removeClass('border-danger')
//
//             } else {
//                 $('.js-promocode').addClass('border-danger')
//             }
//         }
//     });
// }


// $('body').on('click', '.js-create-order', (e) => {
//     $(e.target).attr('disabled', true)
//     createOrderClient(e.target)
// })

// function createOrderClient(btn) {
//     let shoppingCart = document.querySelector('.shopping-cart')
//     let jsCartFirstName = document.querySelector('.js-cart-first-name')
//     let jsCartLastName = document.querySelector('.js-cart-last-name')
//     let jsCartPhone = document.querySelector('.js-cart-phone')
//     let jsCartEmail = document.querySelector('.js-cart-email')
//     let jsCartAddress = document.querySelector('.js-cart-address')
//     let promocode = document.querySelector('.js-promocode')
//     let modalCart = document.querySelector('#modal-cart')
//     let modalCartBackdrop = document.querySelector('.modal-backdrop.fade.show')
//     let code = $('.js-cart-phone-block').find('.iti__selected-dial-code').html()
//
//
//     if (shoppingCart.classList.contains('js-user-have-phone')) {
//         createOrder()
//     } else {
//         showLoader = true
//
//         axios.post('/user/update', {
//             first_name: jsCartFirstName.value,
//             last_name: jsCartLastName.value,
//             email: jsCartPhone.value !== '' && jsCartEmail.value,
//             phone: jsCartPhone.value !== '' && code + jsCartPhone.value
//         }).then(function (response) {
//             showLoader = false
//             createOrder()
//         }).catch(function (error) {
//
//             jsCartPhone.closest('div').querySelector('.error-text').innerHtml = 'Phone is required'
//             jsCartPhone.closest('div').querySelector('.error-text').style = ('display: block')
//             jsCartPhone.classList.add('border-danger')
//         })
//
//         return false
//     }
//
//     jsCartPhone && jsCartPhone.addEventListener('input', () => {
//         jsCartPhone.closest('div').querySelector('.error-text').innerHtnl = ''
//         jsCartPhone.classList.remove('border-danger')
//     })
//
//     jsCartAddress && jsCartAddress.addEventListener('select', () => {
//         jsCartAddress.closest('div').querySelector('.error-text').innerHtnl = ''
//         jsCartAddress.classList.remove('border-danger')
//     })
//
//     function createOrder() {
//         let dataToAjax = []
//         let items = document.querySelectorAll('.item')
//
//         items.forEach(item => {
//             let dataColor = item.getAttribute('data-color')
//
//             if (!dataColor) {
//                 item.classList.add('border-danger')
//                 $('.js-notify-error-color').toggleClass('d-none')
//
//                 return false
//             }
//             let objData = {}
//             objData.model_id = item.getAttribute('data-id')
//             objData.color = item.getAttribute('data-color')
//             objData.count = item.querySelector('.quantity input[name="name"]').value
//             objData.type = item.querySelector('.quantity input[name="type"]').getAttribute('data-type')
//
//             dataToAjax.push(objData)
//         })
//
//         let data = {
//             order: dataToAjax,
//             address_id: jsCartAddress.value,
//             promocode: promocode.value
//         }
//
//         showLoader = true
//
//         function checkProperties(obj) {
//             let status = true;
//             items && items.forEach(item => {
//                     let dataColor = item.getAttribute('data-color')
//                     if (!dataColor) {
//                         return status = false
//                     }
//                 }
//             )
//             return status;
//         }
//
//         checkProperties() && axios.post('/order', data).then(function (response) {
//             if (localStorage.getItem('lang') === 'ar-sa') {
//                 window.notify('تم إنشاء الطلب')
//
//             } else {
//                 window.notify('Order created')
//
//             }
//             showLoader = false
//
//             localStorage.removeItem(`cart-${userId}`)
//             window.location.href = response.data
//             modalCart.modal('hide')
//         }).catch(function (error) {
//             showLoader = false
//             $(btn).removeAttr('disabled')
//
//             if (localStorage.getItem('lang') === 'ar-sa') {
//                 window.notify('لم يتم إنشاء الطلب. الرجاء استبدال المنتج', 'error')
//
//             } else {
//                 window.notify('Order not created. Try to replace the product', 'error')
//
//             }
//
//             jsCartAddress.closest('div').querySelector('.error-text').innerHtnl = ''
//             jsCartAddress.closest('div').querySelector('.error-text').style = ('display: block')
//             jsCartAddress.classList.add('border-danger')
//         })
//     }
// }

$('body').on('click', '.js-color-name', function (e) {
    let blockDescription = $(e.target).closest('div').parent('div')
    let blockMain = blockDescription.parent('div').parent('.item')
    let blockMainDropdown = $(e.target).closest('ul').parent('div').parent('div').parent('div').parent('div').parent('.item')
    let spans = $(e.target).siblings('.js-color-name')
    $('.js-create-order').removeAttr('disabled')

    if (blockMain.length !== 0) {
        blockMain.attr('data-color', $(e.target).attr('data-value'))
        blockMain.removeClass('border-danger')
    } else if (blockMainDropdown) {
        blockMainDropdown.attr('data-color', $(e.target).attr('data-value'))
        blockMainDropdown.removeClass('border-danger')
        $(e.target).closest('ul').parent('div').find('a').css('background', $(e.target).attr('data-value'))
        $(e.target).closest('ul').removeClass('active')
    }

    $(e.target).addClass('border-danger border')
    $(spans).each((index, item) => {
        $(item).removeClass('border-danger border')
    })
})

if (href.includes('/register') || href.includes('/login') || href.includes('/sigh-in') || href.includes('reset')) {
    $('body .fa-cart-shopping').addClass('d-none')
}
